<template>
<div class="container main has-submenu" style="margin: auto;" id="top">
  <div id="loading"
    style="text-align: center; margin-top: 150px;" class="panel-body row-fluid" v-if="loading"
    >
      <svg class="spinner" width="45px" height="45px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>
    <div v-else class="mainbody container-fluid">
      <div class="row">
        <div class="row">
            <div style="padding-top:50px;"> </div>
            <div class="col-lg-3 col-md-3 hidden-sm">
                <div class="panel panel-default" style="margin-top: 0;">
                    <div class="panel-body">
                        <div class="media">
                            <div align="center">
                                <img :src="avatarUrl"  style="width:150px; height:150px" class="img-responsive avatar img-circle img-thumbnail"/>
                                <h1 class="panel-title pull-center" style="font-size:20px;">{{account.firstName}} {{account.lastName}} </h1>
                                <!-- <small><a href="#" style="text-decoration:none; color:grey;">Active <i class="fa fa-clock-o" aria-hidden="true"></i> 42 minutes ago</i></a></small> -->
                            </div>
                            <div class="media-body">
                                <div class="list-group">
                                    <!--<a href="#" class="list-group-item"><span class="tagicon glyphicon glyphicon-phone "></span></i>{{account.number}}</a>-->
                                    <router-link to="/account/verification" class="list-group-item" style="margin-right:0px"><i class="fa fa-envelope" aria-hidden="true"></i>{{account.email}} <div class="pull-right"><i title="Email verified" v-if="account.emailVerified" class="fa fa-check-circle ok" style="color: #30ab1c;" aria-hidden="true"></i><i v-else="" title="Email unverified" class="fa fa-exclamation-triangle" style="color: rgb(247, 139, 6);" aria-hidden="true"></i></div></router-link>
                                    <router-link to="/account/verification" class="list-group-item" style="margin-right:0px"><i class="fa fa-mobile" aria-hidden="true" style="font-size:25px"></i>{{account.phoneNumber}} <div class="pull-right"><i title="Phone verified" v-if="account.phoneNumberVerified" class="fa fa-check-circle ok" style="color: #30ab1c;" aria-hidden="true"></i><i v-else="" title="Phone unverified" class="fa fa-exclamation-triangle" style="color: rgb(247, 139, 6); " aria-hidden="true"></i></div></router-link>
                                    <!-- <a href="#" class="list-group-item"><span class="glyphicon glyphicon-th"></span></i>Change PIN</a>
                                    <a href="#" class="list-group-item"><i class="fa fa-lock" aria-hidden="true"></i>Change Password</a>
                                    <a href="#" class="list-group-item"><span class="glyphicon glyphicon-globe"></span></i>Change Language</a> -->
                                    <a href="#" class="list-group-item"><i class="fa fa-flag" aria-hidden="true"></i>{{account.country}}</a>
                                    <a href="#" class="list-group-item"><i class="fa fa-calendar" aria-hidden="true"></i>Register: {{new Date(account.created).toLocaleDateString('fr-FR')}}</a>
                                    <router-link to="/account/edit" class="list-group-item"><i class="fa fa-pencil" aria-hidden="true"></i>Edit profile</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                <div class="panel panel-info">
                    <div class="panel-heading">
                        <h1 class="panel-title" style="font-size:22px;">My Account
                            <router-link
                              v-if="account.emailVerified && account.phoneNumberVerified"
                              :to="{path:'/account/link'}"
                            >
                              <button type="button" title="Add new acount"
                                class="btn btn-info btn-circle btn-lg"
                                style="margin-top: 5px; float: right;"
                              >
                                <i class="fa fa-plus"></i>
                              </button>
                            </router-link>
                        </h1>
                    </div>
                    <div class="panel-body" style="padding: 0; text-align: center;">
                        <div class="tab_container" style="margin-top: 16px; padding: 0; width: 96%;">
                            <input id="tab1" type="radio" name="tabs" checked>
                            <label for="tab1"><i class="fa fa-money"></i><span>Wallet</span></label>

                            <input id="tab2" type="radio" name="tabs">
                            <label for="tab2"><i class="fa fa-credit-card"></i><span>Cards</span></label>

                            <!-- <input id="tab3" type="radio" name="tabs">
                            <label for="tab3"><i class="fa fa-university"></i><span>Bank</span></label> -->

                            <input id="tab4" type="radio" name="tabs">
                            <label for="tab4"><i class="fa fa-gift"></i><span>e-Vouchers</span></label>

                            <section id="content1" class="tab-content">
                              <ul class="list-group">
                                <li class="list-group-item" v-for="wallet in paymentMethods.wallets" v-bind:key="wallet.id"
                                >
                                  <div class="segments" id="wallets">
                                    <div class="item">
                                      <img src="../../../static/img/wallets/lajanCash.png" class="img-responsive" width="90" height="60" style="margin-left:-14px; float: left;"/>
                                    </div>
                                    <div class="item">
                                      <p style="margin-top: 16px; font-size: 16px;">(509) **** {{wallet.last4}}</p>
                                    </div>
                                    <div class="item"><br><a href="#"><i class="fa fa-trash" style="color: red; font-size:18px;" @click.prevent="deleteWallet(wallet.id)"></i></a></div>
                                  </div>
                                    <div class="row">
                                      <div class="col-lg-6 col-md-6">
                                          <div class="card-box tilebox-two tilebox-primary" style="border-left-color: #188ae2">
                                              <a href="#" title="Add money to Lajancash wallet" class="pull-right">
                                                  <svg class="add-money-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 32" width="65px" height="45px" fill="#20BFD6">
                                                      <g>
                                                          <path class="add-money-icon-stroke" d="M34.41,2.57a6.1,6.1,0,0,0-6.13,6.06,6.14,6.14,0,0,0,12.27,0A6.1,6.1,0,0,0,34.41,2.57Zm0,11.11a5.1,5.1,0,0,1-5.13-5.06,5.14,5.14,0,0,1,10.27,0A5.1,5.1,0,0,1,34.41,13.68Z"></path>
                                                          <path class="cls-1" d="M36.85,8.12H34.91V6.18a.5.5,0,0,0-1,0V8.12H32a.5.5,0,0,0,0,1h1.94v1.94a.5.5,0,0,0,1,0V9.12h1.94a.5.5,0,0,0,0-1Z"></path>
                                                          <path class="add-money-icon-stroke" d="M33.25,23.82a.5.5,0,0,0-1,.12c0,.12,0,.38,0,.71-4.71-.44-9.35.21-13.84.85s-9.1,1.29-13.75.83l-.5-12.26L4.58,14a.5.5,0,1,0-.16-1l-.81.15a.5.5,0,0,0-.39.51l.53,13.11a.48.48,0,0,0,0,.08.5.5,0,0,0,.43.4,33.6,33.6,0,0,0,3.8.21,75.81,75.81,0,0,0,10.62-1c4.59-.65,9.33-1.32,14.08-.79l.16,0a.5.5,0,0,0,.48-.5s0,0,0,0C33.3,24.57,33.28,24,33.25,23.82Z"></path>
                                                          <path class="add-money-icon-stroke" d="M33.19,16.5a.5.5,0,0,0-.5.5v4.33c-.46-.09-1.12-.19-2.07-.32a59.87,59.87,0,0,0-14.06.31,34.33,34.33,0,0,1-8.86.26V9.48a24.74,24.74,0,0,0,6.77.13L16,9.51c.09,0,9.06-.82,10-.84a.5.5,0,1,0,0-1c-.94,0-9.67.81-10,.85l-1.51.1A22.27,22.27,0,0,1,7.3,8.38a.5.5,0,0,0-.61.49V22a.5.5,0,0,0,.41.49,18,18,0,0,0,3.38.29,58.59,58.59,0,0,0,6.18-.46A59.15,59.15,0,0,1,30.5,22c1.77.25,3.15.84,3.21-.09l0-4.91A.5.5,0,0,0,33.19,16.5Z"></path>
                                                          <path class="add-money-icon-stroke" d="M16.9,15.27A3.11,3.11,0,1,0,20,12.16,3.11,3.11,0,0,0,16.9,15.27Zm5.22,0A2.11,2.11,0,1,1,20,13.17,2.11,2.11,0,0,1,22.11,15.27Z"></path>
                                                      </g>
                                                  </svg>
                                              </a>
                                              <h6 class="text-primary text-uppercase">Balance HTG Availlable</h6>
                                              <h2 v-if="wallet.balance" class="m-b-10 ballance"><span data-plugin="counterup">{{wallet.balance.htg | currency('HTG ')}}</span></h2>
                                          </div>
                                      </div>
                                      <div class="col-lg-6 col-md-6">
                                          <div class="card-box tilebox-two tilebox-success" style="border-left-color: #4bd396;">
                                              <a href="#" title="Add money to Lajancash wallet" class="pull-right">
                                                  <svg class="add-money-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 32" width="65px" height="45px" fill="#20BFD6">
                                                      <g>
                                                          <path class="add-money-icon-stroke" d="M34.41,2.57a6.1,6.1,0,0,0-6.13,6.06,6.14,6.14,0,0,0,12.27,0A6.1,6.1,0,0,0,34.41,2.57Zm0,11.11a5.1,5.1,0,0,1-5.13-5.06,5.14,5.14,0,0,1,10.27,0A5.1,5.1,0,0,1,34.41,13.68Z"></path>
                                                          <path class="cls-1" d="M36.85,8.12H34.91V6.18a.5.5,0,0,0-1,0V8.12H32a.5.5,0,0,0,0,1h1.94v1.94a.5.5,0,0,0,1,0V9.12h1.94a.5.5,0,0,0,0-1Z"></path>
                                                          <path class="add-money-icon-stroke" d="M33.25,23.82a.5.5,0,0,0-1,.12c0,.12,0,.38,0,.71-4.71-.44-9.35.21-13.84.85s-9.1,1.29-13.75.83l-.5-12.26L4.58,14a.5.5,0,1,0-.16-1l-.81.15a.5.5,0,0,0-.39.51l.53,13.11a.48.48,0,0,0,0,.08.5.5,0,0,0,.43.4,33.6,33.6,0,0,0,3.8.21,75.81,75.81,0,0,0,10.62-1c4.59-.65,9.33-1.32,14.08-.79l.16,0a.5.5,0,0,0,.48-.5s0,0,0,0C33.3,24.57,33.28,24,33.25,23.82Z"></path>
                                                          <path class="add-money-icon-stroke" d="M33.19,16.5a.5.5,0,0,0-.5.5v4.33c-.46-.09-1.12-.19-2.07-.32a59.87,59.87,0,0,0-14.06.31,34.33,34.33,0,0,1-8.86.26V9.48a24.74,24.74,0,0,0,6.77.13L16,9.51c.09,0,9.06-.82,10-.84a.5.5,0,1,0,0-1c-.94,0-9.67.81-10,.85l-1.51.1A22.27,22.27,0,0,1,7.3,8.38a.5.5,0,0,0-.61.49V22a.5.5,0,0,0,.41.49,18,18,0,0,0,3.38.29,58.59,58.59,0,0,0,6.18-.46A59.15,59.15,0,0,1,30.5,22c1.77.25,3.15.84,3.21-.09l0-4.91A.5.5,0,0,0,33.19,16.5Z"></path>
                                                          <path class="add-money-icon-stroke" d="M16.9,15.27A3.11,3.11,0,1,0,20,12.16,3.11,3.11,0,0,0,16.9,15.27Zm5.22,0A2.11,2.11,0,1,1,20,13.17,2.11,2.11,0,0,1,22.11,15.27Z"></path>
                                                      </g>
                                                  </svg>
                                              </a>
                                              <h6 class="text-success text-uppercase">Balance USD Availlable</h6>
                                              <h2 v-if="wallet.balance" class="m-b-10 ballance"><span data-plugin="counterup">{{wallet.balance.usd | currency('USD ')}}</span></h2>
                                          </div>
                                      </div>
                                  </div>
                                  </li>
                                </ul>
                                <div v-if="!account.emailVerified || !account.phoneNumberVerified" class="alert alert-warning fade in"
                                >
                                  Account not verified<br>Please verify your phone number and your email address to add wallets.
                                </div>
                                <div v-else class="alert alert-info fade in" style="text-align:center;" v-show="hasNoWallet">
                                  Link a wallet to your account and use it as a payment method to pay bills
                                </div>
                                <!-- <div id="loading" style="text-align: center; margin-bottom: 50px;" class="panel-body row-fluid" v-if="loading">
                                  <svg class="spinner" width="45px" height="45px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                    <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                                  </svg>
                                </div> -->
                            </section>

                            <section id="content2" class="tab-content">
                                <ul class="list-group">
                                <li class="list-group-item" v-for="creditCard in paymentMethods.cards" v-bind:key="creditCard.id"
                                >
                                  <div class="segments" id="wallets">
                                    <div class="item">
                                      <img v-if="creditCard.brand == 'MasterCard'" src="../../../static/img/wallets/mastercard.jpg" class="img-responsive" width="90" height="60" style="display:inline;"/>
                                        <img v-else
                                          src="../../../static/img/wallets/visas.jpg" class="img-responsive" width="90" height="60" style="display:inline; padding:5px;"/>
                                        *********<span> {{creditCard.last4}}</span>
                                    </div>
                                    <div class="item"><br>{{creditCard.number}}</div>
                                    <!-- <div class="item">
                                      <br>
                                      <a href="#"><i class="fa fa-heart" style="color: pink; font-size:18px;"></i></a>
                                    </div> -->
                                    <div class="item"><br><a href="#"><i class="fa fa-trash" style="color: red; font-size:18px; margin-right:0;" @click.prevent="deleteCard(creditCard.id)"></i></a></div>
                                  </div>
                                </li>
                                </ul>
                                <div v-if="!account.emailVerified || !account.phoneNumberVerified"
                                  class="alert alert-warning fade in"
                                >
                                  Account not verified.<br>Please verify your phone number and your email address to add credit cards<br>
                                </div>
                                <div v-else class="alert alert-info fade in" style="text-align:center;" v-show="hasNoCard">
                                  <i aria-hidden="true" style="font-size:23px; float:left;" class="fa fa-exclamation-triangle"></i>
                                  Link a Credit or debit card to your account and use it as a payment method to pay bills<br>
                                </div>
                            </section>

                            <section id="content4" class="tab-content">
                                <div v-if="hasNoGift" class="alert alert-info fade in">
                                  <!-- <a href="#" class="close" data-dismiss="alert">&times;</a> -->
                                  <!-- <i aria-hidden="true" style="font-size:23px; float:left;" class="fa fa-exclamation-triangle"></i> -->
                                  Vouchers you received will appear in this section<br>
                                </div>
                                <ul v-else class="list-group">
                                  <li class="list-group-item" v-for="giftCard in paymentMethods.gifts" v-bind:key="giftCard.id"
                                  >
                                    <div class="segments" id="wallets">
                                      <div class="item">
                                       <img :src="'../../../static/img/gifts/thumbnail/'+giftCard.slug+'.png'" class="img-responsive" width="100" height="70" style="margin-left:-10px; margin-top:20px;">
                                      </div>
                                      <div class="item"><br>
                                        <span><strong>{{giftCard.merchantName.toUpperCase()}} Voucher</strong></span><br>
                                        <span style="font-size:16px;">
                                          <!-- {{giftCard.valueCurrency.toUpperCase() }} -->
                                          {{giftCard.price | currency('HTG ')}}
                                        </span><br>
                                        <span>+{{giftCard.phoneNumber}}</span>
                                        <p></p>
                                      </div>
                                      <!-- <div class="item"><br><a href="#"><i class="fa fa-heart" style="color: pink; font-size:18px;"></i></a></div> -->
                                      <div class="item"><br><a href="#"><i class="fa fa-trash" style="color: red; font-size:18px;" @click.prevent="deleteGift(giftCard.id)"></i></a></div>
                                    </div>
                                  </li>
                                </ul>
                            </section>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div></div>
</template>
<script>
  import Vue from 'vue'
  import Vue2Filters from 'vue2-filters'
  import { default as swal } from 'sweetalert2'
  import {HTTP, account} from '../../services/account-services.js'

  Vue.use(Vue2Filters)

  export default {
    name: 'Account',
    components: {
      // ContactsList
    },
    data() {
      return {
        active: true,
        account: {},
        paymentMethods: {},
        hasNoWallet: false,
        hasNoCard: false,
        hasNoBank: false,
        hasNoGift: false,
        loading: true,
        ballanceht: 0,
        ballanceus: 0,
        stripeID: '',
        avatarUrl: null
        // avatarUrl: localStorage.getItem('avatarUrl') === 'undefined' ? '../../../static/img/default_avatar.png' : localStorage.getItem('avatarUrl') + '&access_token=' + localStorage.getItem('authToken')
      }
    },
    methods: {
      getPaymentMethod() {
        let app = this
        let userId = localStorage.getItem('userId')
        let token = localStorage.getItem('authToken')
        if (!app.loading) app.loading = true
        HTTP.get(`/accounts/${userId}/paymentMethods?access_token=${token}`).then(response => {
          app.paymentMethods = response.data
          // console.log(response.data)
          // localStorage.setItem('phone', response.data.wallets.phoneNumber)
          // console.log(response.data.wallets[0].phoneNumber)
          if (response.data.wallets.length === 0) {
            app.hasNoWallet = true
          }
          if (response.data.cards.length === 0) {
            app.hasNoCard = true
          }
          // if (response.data.banks.length === 0) {
          //   app.hasNoBank = true
          // }
          if (response.data.gifts.length === 0) {
            app.hasNoGift = true
          }
          if (!app.hasNoGift) {
            let gifts = response.data.gifts
            gifts.forEach((merchant) => {
              let merchantName = merchant.merchantName.toLowerCase()
              merchant.slug = merchant.merchantName.split(' ').join('').toLowerCase()
              if (merchantName.match('rouge')) merchant.slug = 'celerirouge'
              if (merchantName.match('domino')) merchant.slug = 'dominospizza'
            })
          }
          if (!app.hasNoWallet) {
            response.data.wallets.forEach((wallet) => {
              let phone = wallet.phoneNumber
              wallet.last4 = phone.substr(7, phone.length)
            })
          }
          app.loading = false
          // console.log(response.data)
        }).catch(function (error) {
          console.log(error)
        })
      },
      deleteWallet(id) {
        let token = localStorage.getItem('authToken')
        swal({
          title: 'Are you sure who want to delete this wallet ?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          showLoaderOnConfirm: true,
          preConfirm: function () {
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                resolve(
                  HTTP
                    .delete(`/wallet/${id}?access_token=${token}`)
                    .then(function(response) {
                      // Do nothing
                    })
                )
              }, 1500)
            })
          },
          allowOutsideClick: false
        }).then(() => {
          swal({
            type: 'success',
            title: 'Wallet delete successfully',
            html: 'The Wallet has been deleted !'
          })
          this.getPaymentMethod()
        })
      },
      deleteCard(id) {
        let userId = localStorage.getItem('userId')
        let token = localStorage.getItem('authToken')
        swal({
          title: 'Are you sure who want to delete this Card ?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          showLoaderOnConfirm: true,
          preConfirm: function () {
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                resolve(
                  HTTP.delete('/accounts/' + userId + '/cards/' + id + '?access_token=' + token).then(function (response) {
                    console.log(response)
                  })
                )
              }, 1500)
            })
          },
          allowOutsideClick: false
        }).then(() => {
          swal({
            type: 'success',
            title: 'Wallet delete successfully',
            html: 'The Wallet has been deleted !'
          })
          this.getPaymentMethod()
        })
      },
      deleteBank(id) {
        let userId = localStorage.getItem('userId')
        let token = localStorage.getItem('authToken')
        swal({
          title: 'Are you sure who want to delete this bank account ?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          showLoaderOnConfirm: true,
          preConfirm: function () {
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                resolve(
                  HTTP.delete('/accounts/' + userId + '/banks/' + id + '?access_token=' + token).then(function (response) {
                    console.log(response)
                  })
                )
              }, 1500)
            })
          },
          allowOutsideClick: false
        }).then(() => {
          swal({
            type: 'success',
            title: 'Wallet delete successfully',
            html: 'The Wallet has been deleted !'
          })
          this.getPaymentMethod()
        })
      },
      deleteGift(id) {
        // let userId = localStorage.getItem('userId')
        let self = this
        let token = localStorage.getItem('authToken')
        swal({
          title: 'Are you sure who want to delete this gift card ?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve(
                  HTTP.delete(`/vouchers/${id}?access_token=${token}`).then((response) => {
                    // console.log(response)
                    self.getPaymentMethod()
                  })
                )
              }, 1500)
            })
          },
          allowOutsideClick: false
        }).then(() => {
          swal({
            type: 'success',
            title: 'Wallet delete successfully',
            html: 'The Wallet has been deleted !'
          })
          this.getPaymentMethod()
        })
      }
    },
    mounted() {
      // console.log(this.avatarUrl)
      this.$scrollTo('#top', 1000)
      this.getPaymentMethod()
      let app = this
      let userId = localStorage.getItem('userId')
      let authToken = localStorage.getItem('authToken')
      account(userId, authToken).then(function(response) {
        console.log('Result', response.data)
        app.account = response
      }).catch(function(e) {
        console.log('Error', e)
        // if the the token is expired log out the user
        localStorage.removeItem('authToken')
        localStorage.removeItem('userId')
        localStorage.removeItem('ttl')
        localStorage.removeItem('avatarUrl')
        // location.reload()
      })
    },
    beforeMount() {
      if (!localStorage.getItem('authToken')) {
        return this.$router.push('/login')
      }

      let avatarUrl = localStorage.getItem('avatarUrl')
      let defaultAvatarUrl = '/static/img/default_avatar.png'

      if (!avatarUrl) {
        this.avatarUrl = defaultAvatarUrl
      } else {
        this.avatarUrl = avatarUrl
      }
    },
    // computed(){
    //   giftUrl(){
    //     return '../../../static/img/wallets/lajanCash.png'
    //   }
    // },
    props: ['loggedIn']
    // computed: {
    //   filterContacts: function () {
    //     return this.contacts.filter((element) => {
    //       return element.match(this.filterSearch)
    //     })
    //   }
    // }
  }
</script>
<style scoped>
  .list-group-item {
    padding: 3px 10px
  }

  .list-group-item span,
  .list-group-item i {
    margin-right: 10px;
    font-size: 14px;
    color: #337ab7;
  }

  .panel {
    border: 1px solid #ddd;
    background-color: #fcfcfc;
  }

  .panel-heading {
    padding: 0px 15px;
    font-size: 22px;
  }

  .panel .btn-group {
    margin: 15px 0 30px;
  }

  .panel .btn-group .btn {
    transition: background-color .3s ease;
  }
  /*Ballance witget style*/

  .tilebox-primary {
    border-left-color: #188ae2;
  }

  .tilebox-success {
    border-left-color: #4bd396;
  }

  .tilebox-two {
    border-left: 4px solid #f3f3f3;
    background-color: #f3f3f3;
  }

  .card-box {
    padding: 3px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin-bottom: 20px;
  }

  .col-lg-3 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .row {
    margin-right: -10px;
    margin-left: -10px;
  }

  .m-b-10 {
    color: #999;
  }

  .tilebox-two i {
    font-size: 45px;
    opacity: 1;
    /*margin-top: 15px;*/
  }

  .text-dark {
    color: #313a46 !important;
  }

  .text-success {
    color: #4bd396 !important;
  }

  .text-primary {
    color: #188ae2 !important;
  }

  .card-box h2 {
    animation: fadeInScale 0.7s ease-in-out;
  }

  .pull-right {
    display: flex;
    justify-content: space-between;
  }

  .panel-info {
    margin-top: 0;
    background-color: white;
  }
  /*Fun begins TABS CSS*/

  .tab_container {
    width: 90%;
    margin: 0 auto;
    padding-top: 10px;
    position: relative;
  }

  input,
  section {
    clear: both;
    padding-top: 10px;
    display: none;
  }

  .tab_container label {
    font-weight: 700;
    font-size: 18px;
    display: block;
    float: left;
    width: 33.333333%;
    padding: 1em;
    color: #757575;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
    /*background: #f0f0f0;*/
    background: #E0FFFF;
  }

  .tab_container span{
    color: #3b7795;
    font-weight: normal;
  }

  @media (min-width: 480px) {
  ::-webkit-scrollbar-thumb {
    background-color: #26a0da;
  }
}

  #tab1:checked~#content1,
  #tab2:checked~#content2,
  #tab3:checked~#content3,
  #tab4:checked~#content4,
  #tab5:checked~#content5 {
    display: block;
    padding: 0px;
    background: #fff;
    color: #999;
    /*border-bottom: 2px solid #f0f0f0;*/
  }

  .tab_container .tab-content p,
  .tab_container .tab-content h3 {
    -webkit-animation: fadeInScale 0.7s ease-in-out;
    -moz-animation: fadeInScale 0.7s ease-in-out;
    animation: fadeInScale 0.7s ease-in-out;
  }

  .tab_container .tab-content h3 {
    text-align: center;
  }

  .tab_container [id^="tab"]:checked+label {
    background: #fff;
    box-shadow: inset 0 3px #0CE;
  }

  .tab_container [id^="tab"]:checked+label .fa {
    color: #0CE;
  }

  label .fa {
    font-size: 1.3em;
    margin: 0 0.4em 0 0;
  }
  /*Media query*/

  @media only screen and (max-width: 900px) {
    label span {
      display: none;
    }

    .tab_container {
     width: 98%;
    }
  }
  /* tab */

  .tab-content .wallet_button {
    display: block;
    padding-bottom: 30px;
  }

  .wallet_button button {
    margin-left: 20px;
  }

  .ballance span {
    text-align: center;
    font-size: 20px !important;
  }

.btn-circle.btn-lg {
  width: 40px;
  height: 40px;
  padding: 1px 12px;
  font-size: 18px;
  line-height: 2;
  border-radius: 25px;
}
.segments {
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    vertical-align: center;
    padding-left: 1.083em;
}
.item{
  font-size: 16px;
}
.blueButton{
  font-size: 20px;
}

.pull-right i{
  font-size: 17px;
  margin-top: 5px;;
}
@media (min-width: 480px) {
  .item img{
  padding:5px;
  }
}
@media (max-width: 480px) {
  .item img{
  margin-left: -10px;
  padding-top: 5px;
  padding-bottom: 5px;
  }
  .col-lg-3, .col-xs-12 {
    padding-left: 0;
    padding-right: 0;
    margin-left: -5px;
    margin-right: -5px;
  }
}
.tab-content li{
  margin-bottom:5px;
}
.tab-content li:hover{
    border: 1px solid #CBCBD1;
    box-shadow: 0 0 0 1px #4FC0E8;
}

</style>



// WEBPACK FOOTER //
// src/components/Account/Account.vue